import { gql } from 'urql'

export const FragVodClassCard = gql`
  fragment VodClassCard on VodClassCard {
    id
    slug
    title
    guideName
    guideAvatarUrl
    guideId
    imageUrl
    bookmarked
    maxWidthImageUrl
    durationSeconds
  }
`
